import type { IScr, IScrBaseline } from '@/interfaces'
import { Scr, ScrBaseline } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'

export class ProductionService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}

	async getWorkorderBaseline(id: number): Promise<IScrBaseline> {
		return this.getData<IScrBaseline>(`${APIEndpoints.production}/workorder/request/${id}`)
			.then((data) => {
				return new ScrBaseline(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getWorkorderScr(id: number): Promise<IScr> {
		return this.getData<IScr>(`${APIEndpoints.production}/workorder/${id}`)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getWorkOrderScrReview(id: number): Promise<IScr> {
		return this.getData<IScr>(`${APIEndpoints.production}/workorder/request/${id}/review`)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async addWorkorderRequest(scr: IScr): Promise<IScr> {
		return this.postData<IScr>(`${APIEndpoints.production}/workorder/request/add`, scr)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async rejectWorkorderRequestFinance(id: number, notes: string): Promise<IScr> {
		// pass in an object with notes as the body
		const obj = { notes: notes }
		return this.patchData<object, IScr>(`${APIEndpoints.production}/workorder/request/${id}/reject/finance`, obj)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async rejectWorkorderRequestOperations(id: number, notes: string): Promise<IScr> {
		const obj = { notes: notes }
		return this.patchData<object, IScr>(`${APIEndpoints.production}/workorder/request/${id}/reject/operations`, obj)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async approveWorkorderRequestFinance(id: number): Promise<IScr> {
		return this.patchData<null, IScr>(`${APIEndpoints.production}/workorder/request/${id}/approve/finance`, null)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async approveWorkorderRequestOperations(id: number): Promise<IScr> {
		return this.patchData<null, IScr>(`${APIEndpoints.production}/workorder/request/${id}/approve/operations`, null)
			.then((data) => {
				return new Scr(data)
			})
			.catch((err) => {
				throw err
			})
	}
}
